import gradient1 from "@/assets/gradients/gradient_1.svg";
import gradient2 from "@/assets/gradients/gradient_2.svg";
import gradient3 from "@/assets/gradients/gradient_3.svg";
import gradient4 from "@/assets/gradients/gradient_4.svg";
import gradient5 from "@/assets/gradients/gradient_5.svg";
import gradient6 from "@/assets/gradients/gradient_6.svg";
import gradient7 from "@/assets/gradients/gradient_7.svg";
import gradient8 from "@/assets/gradients/gradient_8.svg";
import gradient9 from "@/assets/gradients/gradient_9.svg";
import gradient10 from "@/assets/gradients/gradient_10.svg";
import gradient11 from "@/assets/gradients/gradient_11.svg";
import gradient12 from "@/assets/gradients/gradient_12.svg";
import gradient13 from "@/assets/gradients/gradient_13.svg";
import gradient14 from "@/assets/gradients/gradient_14.svg";
import gradient15 from "@/assets/gradients/gradient_15.svg";

/** Gradient image URLs from `src/assets/gradients/`. */
export const AVATAR_GRADIENT_URLS = [
  gradient1,
  gradient2,
  gradient3,
  gradient4,
  gradient5,
  gradient6,
  gradient7,
  gradient8,
  gradient9,
  gradient10,
  gradient11,
  gradient12,
  gradient13,
  gradient14,
  gradient15,
] as const;

/** Stable gradient pick for a user id, email, etc. */
export function pickAvatarGradientUrl(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % AVATAR_GRADIENT_URLS.length;
  return AVATAR_GRADIENT_URLS[index]!;
}
